import { render, staticRenderFns } from "./ChannelStylesDeleteModal.vue?vue&type=template&id=6046766c&scoped=true&"
import script from "./ChannelStylesDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelStylesDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6046766c",
  null
  
)

export default component.exports